import { ReactComponent as Logo } from './logo/logo-ecoo.svg';
import {
    additionalPurpleGradient,
    aquaGradientColors,
    blueGradientColors,
    purpleGradient,
    purpleGradientColors,
    redGradientColors,
    turquoiseGradientColors
} from './colors/colors';
import { bannerImages } from './backgrounds/ecoo';
const palette = {
    themeGradient: {
        primary: purpleGradient,
        secondary: additionalPurpleGradient
    },
    gradientColors: {
        primary: purpleGradientColors,
        secondary: aquaGradientColors,
        success: aquaGradientColors,
        error: redGradientColors,
        info: blueGradientColors,
        warning: turquoiseGradientColors
    },
    dashboardGradients: [
        {
            start: purpleGradientColors[0],
            end: purpleGradientColors[1]
        },
        {
            start: aquaGradientColors[0],
            end: aquaGradientColors[1]
        },
        {
            start: redGradientColors[0],
            end: redGradientColors[1]
        },
        {
            start: blueGradientColors[0],
            end: blueGradientColors[1]
        },
        {
            start: turquoiseGradientColors[0],
            end: turquoiseGradientColors[1]
        }
    ],
    defaultDashboardGradient: {
        start: purpleGradientColors[0],
        end: purpleGradientColors[1]
    }
};

const config = {
    title: 'Ecoo',
    logo: Logo,
    palette,
    bannerImages,
    allowMerchantRegistration: false,
    allowGoogleAuth: false
};

export default config;
